export enum EntityStatus {
  Unchanged,
  New,
  Updated,
  Deleted,
}
